import React, { useState } from 'react';
import axios from 'axios';
import { getUploadUrl } from '../services/api';
import {
  validateImageFile,
  generatePreview,
  resizeMenuItem,
  resizeRestaurantLogo,
} from '../utils/imageUtils';
import './ImageUpload.css';

function ImageUpload({ resourceType, resourceId, currentImageUrl, onImageUploaded }) {
  const [previewUrl, setPreviewUrl] = useState(currentImageUrl || null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setError(null);
    setUploading(true);

    try {
      // 1. Validar archivo
      const validation = validateImageFile(file, 5);
      if (!validation.valid) {
        setError(validation.error);
        setUploading(false);
        return;
      }

      // 2. Generar preview inmediato
      const preview = await generatePreview(file);
      setPreviewUrl(preview);

      // 3. Redimensionar imagen según el tipo de recurso
      console.log('[ImageUpload] Redimensionando imagen...');
      let resizedFile;
      if (resourceType === 'restaurants') {
        resizedFile = await resizeRestaurantLogo(file);
      } else {
        resizedFile = await resizeMenuItem(file);
      }

      // 4. Obtener presigned URL del backend
      const { uploadUrl, imageUrl } = await getUploadUrl(
        resourceType,
        resourceId,
        resizedFile.type
      );

      // 5. Subir archivo redimensionado directamente a S3
      await axios.put(uploadUrl, resizedFile, {
        headers: {
          'Content-Type': resizedFile.type,
        },
      });

      // 6. Notificar al componente padre con la URL de CloudFront
      onImageUploaded(imageUrl);

      console.log('[ImageUpload] Imagen subida exitosamente:', imageUrl);
    } catch (err) {
      console.error('Error uploading image:', err);
      setError('Error al subir la imagen. Por favor intenta nuevamente.');
      setPreviewUrl(currentImageUrl || null);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="image-upload">
      {previewUrl && (
        <div className="image-preview">
          <img src={previewUrl} alt="Preview" />
          {uploading && (
            <div className="image-upload-overlay">
              <div className="spinner"></div>
              <span>Optimizando y subiendo...</span>
            </div>
          )}
        </div>
      )}

      <div className="image-upload-actions">
        <input
          type="file"
          accept="image/*"
          onChange={handleFileSelect}
          disabled={uploading}
          id="image-file-input"
          style={{ display: 'none' }}
        />

        <label
          htmlFor="image-file-input"
          className={`btn btn-secondary ${uploading ? 'disabled' : ''}`}
        >
          {uploading ? 'Subiendo...' : previewUrl ? 'Cambiar imagen' : 'Seleccionar imagen'}
        </label>
      </div>

      {error && <p className="error-message">{error}</p>}

      {uploading && (
        <p className="upload-info">⚡ Redimensionando y optimizando imagen automáticamente...</p>
      )}
    </div>
  );
}

export default ImageUpload;
